export const AutoHyperfHost = process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:9501/"
    : "https://qyh-next-server.zhang66.cn/"


// WEBPACK FOOTER //
// ./src/config/index.js